import { useEffect, useRef, useState } from 'react';

// Countdown against the server deadline (corrected for client clock skew).
export default function useCountdown(deadlineAt, serverNow, onExpire) {
  const skew = useRef(0);
  const fired = useRef(false);
  const cb = useRef(onExpire);
  cb.current = onExpire;
  const [left, setLeft] = useState(null);

  useEffect(() => {
    if (!deadlineAt) return undefined;
    skew.current = serverNow ? new Date(serverNow).getTime() - Date.now() : 0;
    fired.current = false;
    const tick = () => {
      const ms = new Date(deadlineAt).getTime() - (Date.now() + skew.current);
      const secs = Math.max(0, Math.ceil(ms / 1000));
      setLeft(secs);
      if (secs === 0 && !fired.current) {
        fired.current = true;
        cb.current?.();
      }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [deadlineAt, serverNow]);

  return left;
}

export const fmtClock = (s) => `${String(Math.floor((s || 0) / 60)).padStart(2, '0')}:${String((s || 0) % 60).padStart(2, '0')}`;
